<script>
    export default {
        name: "FooterPaymentIcons",
        props: {
            /** @type {import('vue').PropOptions<"light" | "dark" | "grey">} */
            color: {
                type: String,
                default: "light",
                validator: (v) => ["light", "dark", "grey"].includes(v),
            },
            exclude: {
                type: Array,
                default: () => [],
            },
        },
        computed: {
            icons() {
                const postfix = this.color ? `--${this.color}` : "";
                return [
                    { name: "cash", image: `cash${postfix}.png` },
                    { name: "mir", image: `mir${postfix}.svg` },
                    { name: "visa", image: `visa${postfix}.svg` },
                    { name: "mastercard", image: `mastercard${postfix}.svg` },
                    { name: "ypay", image: `ypay${postfix}.svg` },
                    { name: "sbp", image: `sbp${postfix}.svg` },
                    { name: "tinkoff-pay", image: `tinkoff-pay${postfix}.svg` },
                ].filter((icon) => !this.exclude.includes(icon.name));
            },
        },
    };
</script>

<template>
    <div class="payment-icons">
        <div class="payment-icons__list">
            <div class="payment-icons__item" v-for="icon in icons" :key="icon.name">
                <img :src="`/static/assets/payment/${icon.image}?v=23122023`" alt="" />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .payment-icons__list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0 -5px -15px;
        @include bp($bp-desktop-sm) {
            margin: 0 -10px -20px;
            justify-content: flex-start;
        }
    }

    .payment-icons__item {
        margin: 0 5px 15px;
        img {
            height: 22px;
        }
        @include bp($bp-desktop-sm) {
            img {
                height: 18px;
            }
        }
        @include bp($bp-desktop-lg) {
            margin: 0 10px 20px;
            img {
                height: 22px;
            }
        }
    }
</style>
